import React, { useEffect } from 'react';
import logo from '../../assets/collaborationlogo.png';
import { Field, Form, FormElement } from "@progress/kendo-react-form";
import { login } from "../../actions/index.js"
import { authUrl } from "../../actions/authUrl.js";
import { Input } from "@progress/kendo-react-inputs";
import { getter } from "@progress/kendo-react-common";
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

function Login(props) {
  const navigate = useNavigate();
  const [formError, setFormError] = React.useState(null);
  const dispatch = useDispatch();
  const { sso } = useSelector(state => state.ssoReducer);


  const onSubmit = (values) => {
    dispatch(authUrl(getter("email")(values), () => {
      dispatch(login(getter("email")(values), getter("password")(values)))
      .then(() => {
        navigate('/dashboard')
      })
      .catch((err) => console.log(err));
    }));
  }

  useEffect(() => {
    if (sso?.length) {
      window.location.href = sso;
    }
  }, [sso])

  return (
    <div style={styles.loginContainer}>
      <header className="App-header">
        <img alt="Alastar Collaboration Logo" src={logo} style={styles.logo} />
        <Form
          onSubmit={onSubmit}
          render={(formRenderProps) => (
            <FormElement style={{ maxWidth: 650 }}>
              <fieldset className={"k-form-fieldset"}>
                <legend className={"k-form-legend"}>
                </legend>
                {formError ? <div className={"k-messagebox k-messagebox-error"}>
                  {formError.map((val) => {
                    return <div>{val}</div>;
                  })}
                </div> : null}
                <div className="mb-3">
                  <Field
                    name={"email"}
                    component={Input}
                    placeholder={"Email"}
                    style={styles.formField}
                  />
                </div>

                <div className="mb-3">
                  <Field 
                    name={"password"}
                    component={Input}
                    placeholder={"Password"}
                    type={"password"}
                    style={styles.formField}
                  />
                </div>
              </fieldset>
              <div className="k-form-buttons">
                <button
                  type={"submit"}
                  className="k-button"
                  disabled={!formRenderProps.allowSubmit}
                  style={styles.loginBtn}
                >
                  Log in
                </button>
              </div>
            </FormElement>
          )}
        />
      </header>
    </div>
  );
}

const styles = {
  loginContainer: {
    display: "flex",
    justifyContent: "center",
    height: "100vh",
    alignItems: "center",
    backgroundColor: 'white',
  },
  logo: {
    height: "180px",
  },
  formField: {
    marginTop: 20
  },
  loginBtn: {
    marginTop: 10,
    padding: 10,
  },
}

export default Login;
